define('SageDotCom/Components/Content/Buttons/MicroButton',[
    "jquery",
    "eventManager",
    "score_bootstrap/Components/Button",
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/buttonClick'
    ],
    function ($, eventManager, baseButton, tealium, buttonClickEvent) {
        function MicroButton(scope, clickMessagesTransmitting, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
            Object.defineProperties(this, {
                $scope: {
                    enumerable: true, value: $(scope)
                }
            });

            var setMicroTextWidth = function () {
                var microTextParent = $(scope).parent();
                if (microTextParent.hasClass("micro-text-horizontal")){
                    return;
                }

                var microText = microTextParent.find("p.micro-text");
                if (microText === null || microText.length === 0) {
                    return;
                }

                if ($(scope).parents(".score-carousel").length === 1) {
                    var containerEl = $(scope).parents(".item");
                    //makes the slide in the carousel visible on page load so that the width of the button can be calculated and applied to micro text
                    $(containerEl).addClass("show");
                    microText.outerWidth($(scope).outerWidth());
                    $(containerEl).removeClass("show");
                }

                if ($(scope).outerWidth() !== 0) {
                    microText.outerWidth("auto");
                    microText.outerWidth($(scope).outerWidth());
                }
            }

            $(scope).attr('data-tracking', buttonClickEvent.getName());

            this.$scope.on("click", function (event) {
                var data = buttonClickEvent.GenerateEventMetadata(event.currentTarget);
                tealium.event(data);
            });

            var buttonScope = new baseButton(scope,
                clickMessagesTransmitting || [],
                stateChangeMessages || [],
                onShowMessagesPerformer || [],
                onHideMessagePerformer || []);

            setMicroTextWidth();

            $(scope).matchHeight(true);

            var resizeFinished = undefined;
            $(window).resize(function () {
                clearTimeout(resizeFinished);
                resizeFinished = setTimeout(function () {
                    setMicroTextWidth();
                }, 250);
            });

            return buttonScope;
        }
        
        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new MicroButton(args.scope, args.ClickMessagesTransmitting, args.StateChangeMessagesTransmitting, args.ShowActionMessages, args.HideActionMessages);
        };
    });

